<template>
    <va-edit-layout>
        <users-form :id="id" :item="item" :title="title"></users-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"]
};
</script>
